import { useState } from "react";
import { useTranslation } from "react-i18next";

import { SectionHeader, Table } from "@pentabd/ui";

import { DeleteConfirmationModal } from "@components";
import { TableColumn } from "./TableColumn";

import { DisciplineType } from "@type/HRM/discipline";

interface DisciplineTableProps {
  disciplineInfo: DisciplineType[];
  deleteDisciplineTable: (id: number) => void;
  onUpdateDiscipline: (data: any) => void;
  onOpen: (data: any) => void;
  isProfileDisabled: boolean;
}

export const DisciplineTable = ({
  deleteDisciplineTable,
  disciplineInfo,
  onOpen,
  isProfileDisabled,
}: DisciplineTableProps) => {
  const { t } = useTranslation();

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [itemID, setItemID] = useState<number>();

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    closeConfirmationModal();
    deleteDisciplineTable(itemID as number);
  };

  const handleDeleteAction = (id: number | string) => {
    setIsConfirmationModalOpen(true);
    setItemID(id as number);
  };

  return (
    <div className="py-10">
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          action={deleteAction}
          onClose={closeConfirmationModal}
        />
      )}
      <div className="pb-10">
        <SectionHeader title={t("EMPLOYEE.DISCIPLINE.TABLE.LABEL")} />
      </div>
      <Table
        columns={TableColumn({ onOpen, handleDeleteAction, isProfileDisabled })}
        rows={disciplineInfo || []}
      />
    </div>
  );
};
